// StepProgress.tsx
/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';

const steps = ['Security', 'Setup', 'Personalize'] as const;
export type StepKey = (typeof steps)[number];

interface StepProgressProps {
  current: StepKey;
}

const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
  max-width: 600px;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const Bar = styled.div<{ $active: boolean }>`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ $active }) => ($active ? '#5E84ED' : '#2B2D33')};
  transition: background-color 0.2s;
`;

const Label = styled.span<{ $active: boolean }>`
  margin-top: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: ${({ $active }) => ($active ? '#5E84ED' : '#B7BDCBB2')};
`;

export const StepProgress: React.FC<StepProgressProps> = ({ current }) => {
  const activeIndex = steps.indexOf(current);

  return (
    <Container>
      {steps.map((step, idx) => (
        <StepItem key={step}>
          <Bar $active={idx <= activeIndex} />
          <Label $active={idx <= activeIndex}>{step}</Label>
        </StepItem>
      ))}
    </Container>
  );
};
